export const paymentMethods = {
  CHECK_CAPTURE: 0,
  ACH_TRANSFER: 1,
  DIGITAL_CHECK: 2,
  ELECTRONIC_PAYMENT: 3,
  WIRE_TRANSFER: 4,
  CREDIT_CARD: 5,
};
